import React, { AnchorHTMLAttributes, ButtonHTMLAttributes, FC, forwardRef, ReactNode, Ref } from 'react';
import { LinkProps } from 'react-router-dom';
import styled, { css } from 'styled-components';
import Button from './Button';

export interface Props
    extends ButtonHTMLAttributes<HTMLButtonElement>,
        Partial<Omit<LinkProps, keyof AnchorHTMLAttributes<{}>>> {
    icon?: ReactNode;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    as?: keyof React.JSX.IntrinsicElements | React.ComponentType<React.PropsWithChildren<any>>;
    rel?: string;
    ref?: Ref<HTMLButtonElement | HTMLAnchorElement>;
}

const LabelButton: FC<React.PropsWithChildren<Props>> = forwardRef(({ icon, children, ...props }, ref) => (
    <StyledButton variant="primary" size="small" ref={ref} {...props}>
        <Icon className="button-icon">{icon}</Icon>
        {children}
    </StyledButton>
));

export default LabelButton;

const StyledButton = styled(Button)<Required<Props>>`
    height: 28px;
    z-index: 1;
    font-family: ${({ theme }) => theme.fontFamily.body};
    font-weight: 400;
    color: ${({ theme }) => theme.colors.neutral['0']};
    --border-color: none;
    border-radius: 24px;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    pointer-events: none;

    :disabled {
        box-shadow: none;
        --border-color: none;
        color: ${({ theme }) => theme.colors.neutral['0']};
        background: rgba(0, 0, 0, 0.5);
        cursor: none;
    }

    ${({ disabled }) =>
        !disabled &&
        css`
            pointer-events: auto;
            :hover,
            :focus,
            :active {
                background: rgba(0, 0, 0, 0.9);
                --border-color: none;
                color: ${({ theme }) => theme.colors.neutral['0']};
            }
        `};
`;

const Icon = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: ${({ theme }) => theme.spacing['20_Tiny']};
    font-size: 1.6rem;
    > svg {
        width: 1em;
        height: 1em;
    }
`;
